export default __webpack_public_path__ + "static/media/openDrawer.623f535a.svg";